import * as React from 'react';
import { FieldRenderProps, useFormState } from 'react-final-form';
import { Field } from '../form/Field';
import { MFieldProps } from '../form/types';
import { FilterItem } from './FilterItem';
import { FilterFieldProps, getFilterFieldFormValuePath } from './types';
import { Autocomplete } from '../autocomplete/Autocomplete';
import { useEffect, useRef } from 'react';
import { get } from 'lodash-es';
import { refreshItems } from '../autocomplete/utils';
import { DATA_FILTER_INPUT } from '../common/data';

export type CompProps = MFieldProps<React.ComponentProps<typeof Autocomplete>> &
  FilterFieldProps & {
    getItemsByIds?: (ids: (number | string)[]) => Promise<any[]>;
  };
export const FilterAutocomplete = React.forwardRef<HTMLInputElement, CompProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      // @ts-ignore
      label,
      onChange: customOnChange,
      disabled,
      size,
      filterType,
      onSearchItems,
      getItemsByIds,
      extendedFilter,
      ...other
    },
    ref
  ) => {
    const { values } = useFormState();
    const [editedValues, setEditedValues] = React.useState<any[]>();

    const selectedItem: undefined | any = get(
      values,
      getFilterFieldFormValuePath(name, filterType)
    );
    const currentValuesRef = useRef<any>(undefined);
    useEffect(() => {
      if (getItemsByIds) {
        if (currentValuesRef.current !== selectedItem) {
          // @ts-ignore
          refreshItems(
            // @ts-ignore
            setEditedValues,
            selectedItem ? [selectedItem?.id] : [],
            getItemsByIds
          );

          currentValuesRef.current = selectedItem;
        }
      }
    }, [selectedItem]);

    return (
      <FilterItem
        name={name}
        className={className}
        label={label}
        disabled={disabled}
        filterType={filterType}
        extendedFilter={extendedFilter}
      >
        <Field
          name={getFilterFieldFormValuePath(name, filterType)}
          validate={validate}
        >
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<any>) => {
            let editItem = value; // vybrana editovana polozky (pokud existuje) a puvodni polozka (pokud neexistuje editovana)

            if (editedValues) {
              editItem =
                editedValues.find((item) => item.id === value?.id) || value;
            }
            return (
              <Autocomplete<any, any>
                {...DATA_FILTER_INPUT(name)}
                // @ts-ignore
                ref={ref}
                inputProps={{
                  size: size,
                }}
                className={inputClassName}
                {...nother}
                {...other}
                disabled={disabled || meta.submitting}
                onChange={(newValue: any) => {
                  currentValuesRef.current = newValue;
                  onChange({ target: { name, value: newValue } });
                  if (editedValues) {
                    setEditedValues(
                      editedValues?.filter((i) => newValue?.id !== i.id)
                    );
                  }
                }}
                onSearchItems={onSearchItems}
                onBlur={() => {}}
                value={editItem}
              />
            );
          }}
        </Field>
      </FilterItem>
    );
  }
);
